// extracted by mini-css-extract-plugin
export default {"root":"QuestionHeader_root__9AgxC","title":"QuestionHeader_title__HJhLF"};